import React from 'react';
import { injectIntl } from 'react-intl';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import CreacheckBillingConditions from 'components/layout/whiteLabel/CreacheckBillingConditions';
import CreacheckItemCalculation from 'components/layout/item/CreacheckItemCalculation';
import { Row, Col } from 'react-bootstrap';
import FormInput from 'components/forms/FormInput';

class WhiteLabelFinancialSettings extends EntityPropsUpdater {
  render() {
    const {
      entity,
      entityLoaded,
      disabled,
      inModal,
      intl: { messages },
    } = this.props;

    if (!entityLoaded) {
      return <div className="clearfix" />;
    }

    return (
      <div className="clearfix">
        <Row>
          <Col xs={12} md={inModal ? 12 : 4}>
            <CreacheckBillingConditions
              inModal={inModal}
              entity={entity}
              updateEntity={this.updateEntity}
              disabled={disabled}
            />
          </Col>

          <Col xs={12} md={inModal ? 12 : 4}>
            <CreacheckItemCalculation
              inModal={inModal}
              entity={entity}
              updateEntity={this.updateEntity}
              disabled={disabled}
            />
          </Col>

          <Col xs={12} md={inModal ? 12 : 4}>
            <div className="panel panel-transparent">
              <div className="panel-body">
                <p>{messages.invoice_email_bcc.send_new_invoice_email_bcc}</p>
                <div className="form-group-attached">
                  <FormInput
                    label={messages.invoice_email_bcc.email_address_bcc}
                    infoText={messages.invoice_email_bcc.info_text}
                    name="invoiceEmailBcc"
                    value={entity.getInvoiceEmailBcc()}
                    meta={entity.getInvoiceEmailBccMetaInformation()}
                    validation={entity.getInvoiceEmailBccValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                    type="text"
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
WhiteLabelFinancialSettings.defaultProps = {
  inModal: false,
};

export default injectIntl(WhiteLabelFinancialSettings);
